import {game} from "../api/entities"
import request from "../api/api.js";

export const actions = {
    listGame: "LIST_GAME",
    updateGameList: "UPDATE_GAME_LIST"
};

export function getGames(query, sort) {
    const _query = [...query, {archived:false}]
    return game.list(actions.listGame, _query, sort, true);
}

export function getAvailableGames() {
    let path = `/games`;
    return request(actions.updateGameList, path, "GET", {});
}


const INITIAL_STATE = {
    games: []
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.listGame:
            return {
                ...state,
                games: action.body ? action.body._items : state.games
            };
        case actions.updateGameList:
            return {
                ...state,
                games: action.body ? action.body.games : state.games
            }
        default:
            return {
                ...state
            };
    }
}


// WEBPACK FOOTER //
// ./src/modules/system/game.js